// Material
import {
  Divider,
  ListItemButton,
  Typography,
  TypographyProps,
  Box,
  SxProps,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { ReactElement } from 'react'

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  width: '100%',
  minHeight: '66px',

  margin: 0,
  padding: '8px 16px',

  outline: 'none',
  justifyContent: 'space-between',
  textAlign: 'inherit',
  backgroundColor: theme.palette.white,
  flexGrow: 0,
  gap: '8px',
  '&.Mui-disabled': {
    opacity: 1,
  },
}))

const StyledDivider = styled(Divider)`
  &:last-child {
    display: none;
  }
`

interface Props {
  primaryIcon?: JSX.Element
  primaryText: string | ReactElement
  primaryTextColor?: TypographyProps['color']
  primaryTextVariant?: TypographyProps['variant']
  secondaryText: string | ReactElement
  secondaryTextColor?: TypographyProps['color']
  secondaryTextVariant?: TypographyProps['variant']
  icon: ReactElement
  onClick: () => any
  primaryTextBadge?: JSX.Element
  disabled?: boolean
  sx?: SxProps
}

export function OptionWithTextItem({
  primaryIcon,
  primaryText,
  primaryTextColor,
  primaryTextVariant,
  secondaryText,
  secondaryTextColor,
  secondaryTextVariant,
  icon,
  onClick,
  primaryTextBadge,
  disabled,
  sx,
}: Props) {
  return (
    <>
      <StyledListItemButton sx={sx} onClick={onClick} disabled={disabled}>
        {primaryIcon && <IconWrapper>{primaryIcon}</IconWrapper>}
        <TextWrapper>
          {typeof primaryText === 'string' ? (
          <Typography
            gutterBottom
            variant={primaryTextVariant || 'body2'}
            component="div"
            color={primaryTextColor || 'neutral1000'}
            sx={{ marginTop: '5px', display: 'flex', gap: '4px' }}
          >
            {primaryText}
            {primaryTextBadge}
          </Typography>
          ) : (
            primaryText
          )}
          {typeof secondaryText === 'string' ? (
          <Typography
            dir="auto"
            variant={secondaryTextVariant || 'caption1'}
            sx={{ margin: '5px 0' }}
            color={secondaryTextColor || 'neutral500'}
          >
            {secondaryText}
          </Typography>
          ) : (
            secondaryText
          )}
        </TextWrapper>
        {icon && (
          <IconWrapper style={{ alignSelf: 'center', marginLeft: 0 }}>
            {icon}
          </IconWrapper>
        )}
      </StyledListItemButton>
      <StyledDivider />
    </>
  )
}

const TextWrapper = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
`

const IconWrapper = styled('div')`
  align-self: start;
  width: fit-content;
  height: fit-content;
  margin-left: 4px;
`
